export default __webpack_public_path__ + "static/media/structure.4224fae3.png";